import { NEWS_ROUTER_ROOT, NEWS_ROUTER_NEW, NEWS_ROUTER_EDIT } from './constants';
import NewsRoot from './NewsRoot';
import NewsNew from './NewsNew';
import NewsEdit from './NewsEdit';
import NewsList from './NewsList';

const settings = {
  router: {
    path: NEWS_ROUTER_ROOT,
    component: NewsRoot,
    indexRoute: {
      component: NewsList
    },
    childRoutes: [
      // new
      {
        path: NEWS_ROUTER_NEW,
        component: NewsNew
      },
      // edit
      {
        path: NEWS_ROUTER_EDIT,
        component: NewsEdit
      }
    ]
  }
};

export default settings;



// WEBPACK FOOTER //
// ./src/components/News/index.js